import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ShoppingBag } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Locations', path: '/locations' },
    { name: 'Franchise', path: '/franchise' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-rush-cream border-b-2 border-rush-blue/10">
      {/* Top announcement bar */}
      <div className="bg-rush-blue text-white text-center py-2 text-sm font-medium">
        🍦 Free topping on orders over $10! 🍓
      </div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <span className="text-4xl font-display text-rush-blue">rush!</span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                className={`text-sm font-semibold transition-all duration-200 hover:scale-105 ${
                  isActive(link.path)
                    ? 'text-rush-blue underline underline-offset-4 decoration-2'
                    : 'text-gray-700 hover:text-rush-blue'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </nav>

          {/* Right side */}
          <div className="hidden md:flex items-center space-x-4">
            <Link to="/franchise">
              <Button className="bg-rush-pink hover:bg-rush-pink/90 text-white font-bold rounded-full px-6">
                Join Us!
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 text-rush-blue hover:bg-rush-blue/10 rounded-full transition-colors"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-rush-blue/10">
            <nav className="flex flex-col space-y-4">
              {navLinks.map((link) => (
                <Link
                  key={link.name}
                  to={link.path}
                  className={`text-base font-semibold transition-colors duration-200 ${
                    isActive(link.path)
                      ? 'text-rush-blue'
                      : 'text-gray-700 hover:text-rush-blue'
                  }`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  {link.name}
                </Link>
              ))}
              <Link to="/franchise" onClick={() => setIsMenuOpen(false)}>
                <Button className="w-full bg-rush-pink hover:bg-rush-pink/90 text-white font-bold rounded-full">
                  Join Us!
                </Button>
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
